







































































































































































































































































































































































































































































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {SelectBox} from '@/interfaces/global-data';
import {
  FtpDownloadProgress,
  GetTaskInfo,
  ResultTableHeaders,
  TaskAndFile,
  TaskData,
  TaskInfoFilterType,
  TaskNoteDTO,
  TaskParams,
  TaskStatus,
  TaskType,
  taskTypesRequiresConfirmation,
  isTaskInBackgroundGeneratableTypesAndStatuses,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeTaskType, localizeTaskStatus } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import moment from 'moment';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import TaskStatusMixin from '@/mixins/task-status';
import Card from '@/components/UI/Card.vue';
import CreateAggregatedReportModal from "@/pages/Sales/SalesTabs/ReportsLogTab/CreateAggregatedReportModal.vue";
import { Modal } from "ant-design-vue";

@Component({
    components: {
        CreateAggregatedReportModal,
        ResultView,
        MultiSelect,
        MarketSelect,
        vSelect,
        DatePicker,
        Card,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY HH:mm:ss');
            }
        },
    },
    methods: {
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})

export default class ReportsLog extends Mixins(LocalData, Toast, Http, TaskStatusMixin) {
    @Prop({required: true}) readonly activeTabKey: string = '' as string;

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$t('shared.selectBox.all') as string}];
    taskIdFilter: string | null = null;
    taskNoteFilter: string | null = null;
    allReportsIds: number[] = [];
    isAllReportsSelected: boolean = false;
    selectedReportsArray: number[] = [];
    updatedDateRange: string[] = [];
    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.notSelected') as string};
    defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

    selectMarket: number = this.defaultFilterValue.value;

    categoryOptions: Array<SelectBox<number>> = [];
    categoryOfProduct: number = this.defaultFilterValue.value;

    subCategoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;
    subCategoryOfProduct: number[] = [];

    typeOptions: Array<SelectBox<TaskType>> = [
        {value: TaskType.PACKAGE_GENERAL_SALES, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_SALES') as string},
        {value: TaskType.PACKAGE_GENERAL_AGGREGATE_SALES, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_AGGREGATE_SALES') as string},
    ];

    typeFilterValues: string[] = [];
    saleTypeFilterValues: string[] = [];
    saleStatusFilterValues: string[] = [];

    selectGroup: number = this.defaultFilterValue.value;
    groupOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectFormat: number = this.defaultFilterValue.value;
    formatOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectRegion: number[] = [];
    regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectCluster: number = this.defaultFilterValue.value;
    clusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectReportType: TaskType | null = null;
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = 'All';

    table: TaskData[] = [];
    refreshTableTimeoutId?: number;

    isTableLoading: boolean = false;
    isTableLoadingFirst: boolean = true;

    isRenderAggregatedReportCreationModal: boolean = false;
    isAggregatedReportCreationModalVisible: boolean = false;
    isCreateAggregatedReportBtnLoading: boolean = false;

    reportList: Array<SelectBox<TaskType | null>> = [
        {value: null, label: this.$t('shared.selectBox.all') as string},
        {value: TaskType.REGULAR, label: this.$t('reportsLog.taskTypes.REGULAR') as string},
        {value: TaskType.PACKAGE_REGULAR, label: this.$t('reportsLog.taskTypes.PACKAGE_REGULAR') as string},
        {value: TaskType.PACKAGE_GENERAL, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_CARTS, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_KVI_CARTS') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_KVI_RECOMMENDS') as string},
        {value: TaskType.PACKAGE_PROMO, label: this.$t('reportsLog.taskTypes.PACKAGE_PROMO') as string},
        {value: TaskType.PACKAGE_GENERAL_PROMO, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_PROMO') as string},
        {value: TaskType.PACKAGE_GENERAL_AGGREGATE_PROMOTION, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_AGGREGATE_PROMOTION') as string},
        {value: TaskType.PACKAGE_SCHEDULE, label: this.$t('reportsLog.taskTypes.PACKAGE_SCHEDULE') as string},
        {value: TaskType.BRUT_FORCE, label: this.$t('reportsLog.taskTypes.BRUT_FORCE') as string},
        {value: TaskType.SEARCH_KVI, label: this.$t('reportsLog.taskTypes.SEARCH_KVI') as string},
        {value: TaskType.PROMO, label: this.$t('reportsLog.taskTypes.PROMO') as string},
        {value: TaskType.PACKAGE_EVENTS, label: this.$t('reportsLog.taskTypes.PACKAGE_EVENTS') as string},
        {value: TaskType.PACKAGE_EVENTS_GENERAL, label: this.$t('reportsLog.taskTypes.PACKAGE_EVENTS_GENERAL') as string},
        {value: TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS, label: this.$t('reportsLog.taskTypes.PACKAGE_PROMO_GENERAL_RECOMMENDS') as string},
        {value: TaskType.PACKAGE_SCENARIO, label: this.$t('reportsLog.taskTypes.PACKAGE_SCENARIO') as string},
        {value: TaskType.PACKAGE_GENERAL_SCENARIO, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_SCENARIO') as string},
        {value: TaskType.PACKAGE_FIXED_PRICE, label: this.$t('reportsLog.taskTypes.PACKAGE_FIXED_PRICE') as string},
        {value: TaskType.PACKAGE_GENERAL_FIXED_PRICE, label: this.$t('reportsLog.taskTypes.PACKAGE_GENERAL_FIXED_PRICE') as string},
        {value: TaskType.REGULAR_PRICE_EXP, label: this.$t('reportsLog.taskTypes.REGULAR_PRICE_EXP') as string},
        {value: TaskType.SCHEDULED_PRICE_EXP, label: this.$t('reportsLog.taskTypes.SCHEDULED_PRICE_EXP') as string},
    ];

    selectStatus: TaskStatus | null = null;
    statusList: Array<SelectBox<TaskStatus | null>> = [
        {value: null, label: this.$t('shared.selectBox.all') as string},
        {value: TaskStatus.ARITHMETICEXCEPTION, label: this.$t('reportsLog.taskStatuses.ARITHMETICEXCEPTION') as string},
        {value: TaskStatus.INQUEUE, label: this.$t('reportsLog.taskStatuses.INQUEUE') as string},
        {value: TaskStatus.WRITETOFILE, label: this.$t('reportsLog.taskStatuses.WRITETOFILE') as string},
        {value: TaskStatus.CALCULATING, label: this.$t('reportsLog.taskStatuses.CALCULATING') as string},
        {value: TaskStatus.ONAPPROVAL, label: this.$t('reportsLog.taskStatuses.ONAPPROVAL') as string},
        {value: TaskStatus.EMPTYDATA, label: this.$t('reportsLog.taskStatuses.EMPTYDATA') as string},
        {value: TaskStatus.RESTARTERROR, label: this.$t('reportsLog.taskStatuses.RESTARTERROR') as string},
        {value: TaskStatus.REJECTED, label: this.$t('reportsLog.taskStatuses.REJECTED') as string},
        {value: TaskStatus.WRITETOFILECOMPLETE, label: this.$t('reportsLog.taskStatuses.WRITETOFILECOMPLETE') as string},
        {value: TaskStatus.ERROREXPORT, label: this.$t('reportsLog.taskStatuses.ERROREXPORT') as string},
        {value: TaskStatus.ERROR, label: this.$t('reportsLog.taskStatuses.ERROR') as string},
        {value: TaskStatus.PROMONOTRECOMMENDED, label: this.$t('reportsLog.taskStatuses.PROMONOTRECOMMENDED') as string},
        {value: TaskStatus.CALCULATING_COMPLETE, label: this.$t('reportsLog.taskStatuses.CALCULATING_COMPLETE') as string},
        {value: TaskStatus.CANCELREPORT, label: this.$t('reportsLog.taskStatuses.CANCELREPORT') as string},
        {value: TaskStatus.EXECUTIONEXCEPTION, label: this.$t('reportsLog.taskStatuses.EXECUTIONEXCEPTION') as string},
        {value: TaskStatus.APPROVED, label: this.$t('reportsLog.taskStatuses.APPROVED') as string},
    ];

    tableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'id', label: '№'},
        {key: 'message', label: this.$t('reportsLog.tableHeaders.status') as string},
        {key: 'updated', label: this.$t('reportsLog.tableHeaders.updated') as string},
        {key: 'userFio', label: this.$t('reportsLog.tableHeaders.userFio') as string},
        {key: 'progress', label: this.$t('reportsLog.tableHeaders.progress') as string},
        {key: 'tradingNetworks.tradingName', label: this.$t('reportsLog.tableHeaders.company') as string},
        {key: 'type', label: this.$t('reportsLog.tableHeaders.type') as string},
        {key: 'group', label: this.$t('reportsLog.tableHeaders.group') as string},
        {key: 'category', label: this.$t('reportsLog.tableHeaders.category') as string},
        {key: 'subcategories', label: this.$t('reportsLog.tableHeaders.subcategories') as string},
        {key: 'format', label: this.$t('reportsLog.tableHeaders.format') as string},
        {key: 'region', label: this.$t('reportsLog.tableHeaders.region') as string},
        {key: 'cluster', label: this.$t('reportsLog.tableHeaders.cluster') as string},
        {key: 'fileResult', label: this.$t('reportsLog.tableHeaders.actions') as string},
        {key: 'ftpSendingStatus', label: ''},
        {key: 'taskNote', label: this.$t('reportsLog.tableHeaders.notes') as string},
        {key: 'taskNoteSecond', label: ''},
    ];

    newTableFields: any[] = [
        {dataIndex: 'selected', scopedSlots: { customRender: 'selected', title: 'selectedTitle' }, fixed: 'left', width: 50},
        {dataIndex: 'fileResult', title: this.$t('reportsLog.tableHeaders.actions') as string, scopedSlots: { customRender: 'fileResult' }, fixed: 'left', stickyColumn: true, ellipsis: true, width: 200},
        {dataIndex: 'taskNote', title: this.$t('reportsLog.tableHeaders.notes') as string, scopedSlots: { customRender: 'taskNote', filterDropdown: 'taskNoteFilter', filterIcon: "taskNoteFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'id', title: '№', scopedSlots: { filterDropdown: 'idFilter', filterIcon: "idFilterIcon" }, width: 80},
        {dataIndex: 'saleName', title: this.$t('reportsLog.tableHeaders.saleName') as string, scopedSlots: { filterDropdown: 'saleNameFilter' }, ellipsis: true, width: 80},
        {dataIndex: 'message', title: this.$t('reportsLog.tableHeaders.status') as string, scopedSlots: { filterDropdown: 'messageFilter', filterIcon: "messageFilterIcon", customRender: 'message' }, ellipsis: true, width: 150},
        {dataIndex: 'updated', title: this.$t('reportsLog.tableHeaders.updated') as string, customRender: (value: number) => new Date(value).toLocaleString('fr-FR'), scopedSlots: { filterDropdown: 'updatedFilter', filterIcon: "updatedFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'userFio', title: this.$t('reportsLog.tableHeaders.userFio') as string, scopedSlots: { filterDropdown: 'userFioFilter', filterIcon: "userFioFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'progress', title: this.$t('reportsLog.tableHeaders.progress') as string, scopedSlots: { customRender: 'progress' }, ellipsis: true, width: 100},
        {dataIndex: 'tradingNetworks.tradingName', title: this.$t('reportsLog.tableHeaders.company') as string, scopedSlots: { filterDropdown: 'tradingNameFilter', filterIcon: "tradingNameFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'type', title: this.$t('reportsLog.tableHeaders.reportType') as string, scopedSlots: { filterDropdown: 'typesFilter', filterIcon: "typesFilterIcon" }, ellipsis: true, width: 180, customRender: (_: string, item: TaskData) => localizeTaskType(item.typeMachine)},
        {dataIndex: 'saleType', title: this.$t('reportsLog.tableHeaders.saleType') as string, scopedSlots: { filterDropdown: 'saleTypesFilter', filterIcon: "saleTypesFilterIcon", customRender: 'saleType' }, ellipsis: true, width: 180},
        {dataIndex: 'saleStatus', title: this.$t('reportsLog.tableHeaders.saleStatus') as string, scopedSlots: { filterDropdown: 'saleStatusesFilter', filterIcon: "saleStatusesFilterIcon", customRender: 'saleStatus' }, ellipsis: true, width: 180},
        {dataIndex: 'group', title: this.$t('reportsLog.tableHeaders.group') as string, scopedSlots: { filterDropdown: 'groupFilter', filterIcon: "groupFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'category', title: this.$t('reportsLog.tableHeaders.category') as string, scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'subcategories', title: this.$t('reportsLog.tableHeaders.subcategories') as string, customRender: (value: string[]) => value.join(', '), scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'format', title: this.$t('reportsLog.tableHeaders.format') as string, scopedSlots: { filterDropdown: 'formatFilter', filterIcon: "formatFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'region', title: this.$t('reportsLog.tableHeaders.region') as string, scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'cluster', title: this.$t('reportsLog.tableHeaders.cluster') as string, scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: "clusterFilterIcon" }, ellipsis: true, width: 120},

        {dataIndex: 'ftpSendingStatus', title: '', scopedSlots: { customRender: 'ftpSendingStatus' }, width: 0},
    ];

    pagination: any = {
        pageSize: 20,
    };

    showSendToFTPSingleReportModal: boolean = false;
    taskToView: TaskAndFile | null = null;
    packageSubtask: TaskAndFile | null = null;
    perPage: number = 20;
    currentPage: number = 1;
    totalRows: number = 0;
    isActiveCalculatingReports: boolean = false;
    isExistsUnfinishedReports: boolean = false;
    showDeleteSingleReportModal: boolean = false;
    taskIdForDelete: number = -1;
    taskIdForSendToFTP: number = -1;
    timeout: number = 1000;
    currentMainTab: string = "list"
    buttonSectionLoaderMap: Map<number, boolean> = new Map<number, boolean>();

    isBulkDownloadInProgress: boolean = false;
    downloadingTaskIds: number[] = [];

    isRowDownloading(taskId: number): boolean {
        return this.downloadingTaskIds.indexOf(taskId) !== -1;
    }

    getButtonSectionLoaderState(taskId: number): boolean {
      return this.buttonSectionLoaderMap.get(taskId) || false
    }

    setButtonSectionLoaderState(taskId: number, state: boolean) {
      this.buttonSectionLoaderMap.set(taskId, state);
    }

    private httpExecutor = new HttpExecutor();

    private canBeShowTypes = [TaskType.PACKAGE_REGULAR, TaskType.PACKAGE_SCHEDULE, TaskType.REGULAR, TaskType.PROMO, TaskType.PACKAGE_PROMO, TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_PROMO, TaskType.PACKAGE_SCENARIO, TaskType.PACKAGE_GENERAL_SCENARIO, TaskType.PACKAGE_EVENTS, TaskType.PACKAGE_EVENTS_GENERAL, TaskType.PACKAGE_GENERAL_KVI_CARTS,
        TaskType.PACKAGE_FIXED_PRICE, TaskType.PACKAGE_GENERAL_FIXED_PRICE, TaskType.SALES, TaskType.PACKAGE_SALES, TaskType.PACKAGE_GENERAL_SALES, TaskType.PACKAGE_GENERAL_AGGREGATE_SALES,
        TaskType.PACKAGE_PROMOTION, TaskType.PACKAGE_GENERAL_PROMOTION, TaskType.PACKAGE_GENERAL_AGGREGATE_PROMOTION, TaskType.REGULAR_PRICE_EXP, TaskType.SCHEDULED_PRICE_EXP];

    created() {
        if (this.$disallowedModules.indexOf('promo') !== -1) {
            const index = this.reportList.findIndex((item) => {
                return item.value === TaskType.PROMO;
            });
            if (index !== -1) {
                this.reportList.splice(index, 1);
            }
        }
    }

    mounted() {
        EventBus.$on('calc', this.onCalcEventReceived);

        this.setSelectMarket(this.$sales.selectMarket.id);

        this.checkUnfinishedAndCancelReports();
        EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        // Вызов идет из ResultView.vue. Работает, не трогать :)
        EventBus.$on('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
        if (this.$route.params.hasOwnProperty('reportId')) {
            this.viewReport(this.$route.params.reportId);
        }

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize
        }, () => {});
    }

    onTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchList({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {});
    }

    onCalcEventReceived(data: TaskData) {
        this.updateTaskRowStatus(data);
    }

    onPackageSubTaskViewEventReceived(task: ResultTableHeaders) {
        this.selectPackageResult(task);
    }

    onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
        console.log("onFtpDownloadProgressReceived")
        this.updateSendToFtpProgress(ftpSendProgress);
    }

    beforeDestroy() {
        clearTimeout(this.refreshTableTimeoutId)
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        EventBus.$off('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
    }

    updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
        const index = this.table.findIndex((item) => {
            return item.id === ftpSendProgress.taskId;
        });
        if (index !== -1) {
            this.table[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
        }
    }

    updateTaskRowStatus(data: TaskData) {
        const index = this.table.findIndex((item) => {
            return item.id === data.id;
        });
        if (index === -1) {
            this.table = [data, ...this.table];
            return;
        }
        this.table[index].message = data.message;
        this.table[index].updated = data.updated;
        this.table[index].fileResult = data.fileResult;
        this.table[index].progress = data.progress;
        this.table[index].status = data.status;
        this.checkUnfinishedAndCancelReports();
        // Костыль - обновляем страницу отчетов, т.к. Пакетный общий отчет создается с пустой группой, категорией и тд и только потом они подтягиваются в виде списка при загрузке страницы
        if (data.type === this.$t('reportsLog.taskTypes.PACKAGE_GENERAL') as string && data.status === 'WriteToFileComplete') {
            this.handleFilter();
        }
    }

    setSelectMarket(market: number) {
        this.selectMarket = market;

        if (LocalData.zeroToNull(market) != null) {
            this.getGroupInfo();
            this.getCategoryInfo();
            this.getSubcategoryInfo();
            this.getStoreFormatsInfo();
            this.getStoreRegionsInfo();
            this.getStoreClustersInfo();
        }
    }

    onMainTabsClicked(key:string) {
        this.currentMainTab = key
        switch (key) {
            case "list":
                // @ts-ignore
                this.handleFilter()
                break;
            default:
                return
        }
    }

    showProgressBar(status: string): boolean {
        return status === 'Calculating'
                || status === 'CalculatingComplete'
                || status === 'WriteToFile';
    }

    showCancelReportsButton(): boolean {
        return !this.isActiveCalculatingReports || this.selectedReportsArray.length === 0;
    }

    showRestartReportsButton(): boolean {
        return !this.isExistsUnfinishedReports || this.selectedReportsArray.length === 0;
    }

    getTaskStatusLabel(status: string): string {
        return localizeTaskStatus(status);
    }

    showCompleteMessage(status: string): boolean {
        return status === 'WriteToFileComplete';
    }

    showDeleteTaskButton(status: string): boolean {
        return (status === TaskStatus.WRITETOFILECOMPLETE
                || status === TaskStatus.EMPTYDATA
                || status === TaskStatus.PROMONOTRECOMMENDED
                || status === TaskStatus.EXECUTIONEXCEPTION
                || status.includes('Error')
                || status.includes('Exception')
                || status === TaskStatus.INQUEUE
                || status === TaskStatus.CANCELREPORT
                || status === TaskStatus.REJECTED
                || status === TaskStatus.ONAPPROVAL);
    }

    checkUnfinishedAndCancelReports() {
        this.httpCheckUnfinishedReports()
                .then((result) => {
                    this.isActiveCalculatingReports = result.data.length > 0;

                })
                .catch(() => {
                    this.showError(this.$t('reportsLog.messages.errorUnfinishedCalc') as string);
                });

        this.httpCheckCancelReports()
                .then((result) => {
                    this.isExistsUnfinishedReports = result.data.length > 0;

                })
                .catch(() => {
                    this.showError(this.$t('reportsLog.messages.errorCancelledCalc') as string);
                });
    }

    cancelAllCalculatingReports(reportsArray: number[]) {
        this.httpCancelTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('reportsLog.messages.infoReportCancelled', { id }) as string);
                        this.checkUnfinishedAndCancelReports();
                        this.handleFilter();
                    });

                })
                .catch(() => {
                    this.showError(this.$t('reportsLog.messages.errorCancelReport') as string);
                });
    }

    restartAllCalculatingReports(reportsArray: number[]) {
        this.httpRestartTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('reportsLog.messages.infoReportRestarted', { id }) as string);
                        this.checkUnfinishedAndCancelReports();
                        this.handleFilter();
                    });

                })
                .catch(() => {
                    this.showError(this.$t('reportsLog.messages.errorRestartReport') as string);
                });
    }

    beforeDeleteFileDialog(taskId: number) {
        this.showDeleteSingleReportModal = true
        this.taskIdForDelete = taskId;
    }

    recalculateGeneralTask(generalTaskId: number) {
        this.httpRecalculateGeneralTask(generalTaskId)
                .then((result) => {
                    this.showInfo(this.$t('reportsLog.messages.infoReportRecalculating', { id: generalTaskId }) as string);
                    this.handleFilter();

                })
                .catch(() => {
                    this.showError(this.$t('reportsLog.messages.errorRecalculateReport') as string);
                });
    }

    beforeSendToFTPDialog(taskId: number) {
        this.showSendToFTPSingleReportModal = true
        this.taskIdForSendToFTP = taskId;
    }

    showDeleteFileDialog(taskId: number) {
        this.deleteTask([taskId]);
    }

    showDeleteCheckedReports(taskIds: number[]) {
        this.deleteTask(taskIds);
        this.selectedReportsArray = [];
    }

    inputTaskNote(taskNoteParam: string, taskId: number) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            const taskParam: TaskNoteDTO = {
                taskNote: taskNoteParam,
            }
            this.httpCreateNote(taskId, taskParam);
        }, 500);
    }

    downloadFile(taskId: number, file: string) {
        if (this.isRowDownloading(taskId)) {
            return;
        }

        this.downloadingTaskIds.push(taskId);

        this.$http.get('/api/task/result', {
            method: 'GET',
            responseType: 'blob',
            params: {
                taskId,
            },
        })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.endsWith('.xlsx') ? file : 'report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('reportsLog.messages.errorDownloadReport') as string);
                })
                .finally(() => {
                    const idx = this.downloadingTaskIds.indexOf(taskId);

                    if (idx !== -1) {
                        this.downloadingTaskIds.splice(idx, 1);
                    }
                });
    }

    downloadFinalReportFile(taskId: number, file: string) {
      this.httpDownloadFinalReportFile(taskId, file)
    }

    generateReport(task: TaskData) {
      this.httpStartGeneratingReport(task.id)
          .then(() => {
            task.status = TaskStatus.WRITETOFILE
            this.refreshTable()
          })
    }

    downloadFiles(taskIds: number[]) {
        if (this.isBulkDownloadInProgress) {
            return;
        }

        this.isBulkDownloadInProgress = true;

        const downloads = taskIds.map((id) => {
            const tableRow = this.table.find((item) => {
                return item.id === id
            });

            return this.$http.get('/api/task/result', {
                method: 'GET',
                responseType: 'blob',
                params: {
                    taskId: id,
                },
            })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // tslint:disable-next-line: no-non-null-assertion
                        link.setAttribute('download', tableRow!!.fileResult);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('reportsLog.messages.errorDownloadReport') as string);
                    });
        });

        Promise.all(downloads).finally(() => {
            this.isBulkDownloadInProgress = false;
        });
    }

    deleteTask(taskIds: number[]) {
        this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    taskIds.forEach((id) => {
                        const index = this.table.findIndex((item) => {
                            return item.id === id
                        });
                        if (index !== -1) {
                            this.table.splice(index, 1);
                        }
                    });
                    this.taskToView = null;
                    this.checkUnfinishedAndCancelReports();
                })
                .catch((err) => {
                    this.showError(this.$t('reportsLog.messages.errorDeleteReport') as string);
                });
    }

    fetchList(ctx: any, callback: (items: any[]) => void) {
        const params: TaskParams = {
            size: ctx.perPage,
            page: ctx.currentPage - 1,
        };

        params.taskIdFilter = this.taskIdFilter
        params.taskNoteFilter = this.taskNoteFilter

        const userFio = this.selectUserFio;
        if (userFio != null && userFio !== 'All') {
            params.userFio = userFio;
        }

        const status = this.selectStatus;
        if (status != null) {
            params.status = status;
        }

        if (this.$sales.selectMarket.id != null) {
            params.tradingId = this.$sales.selectMarket.id;
        }

        const type = this.selectReportType;
        if (type != null) {
            params.type = type;
        }

        const group = LocalData.zeroToNull(this.selectGroup);
        if (group != null) {
            params.group = group;
        }

        const category = LocalData.zeroToNull(this.categoryOfProduct);
        if (category != null) {
            params.category = category;
        }

        const subCategory = LocalData.filterNumberArrays(this.subCategoryOfProduct, true);
        if (subCategory != null) {
            params.subcategories = subCategory.join(',');
        }

        const storeFormat = LocalData.zeroToNull(this.selectFormat);
        if (storeFormat != null) {
            params.storeFormat = storeFormat;
        }

        const region = LocalData.filterNumberArrays(this.selectRegion, true);
        if (region != null) {
            params.storeRegions = region.join(',');
        }

        const cluster = LocalData.zeroToNull(this.selectCluster);
        if (cluster != null) {
            params.storeCluster = cluster;
        }
        if (this.updatedDateRange.length > 0) {
            params.dateBefore = this.updatedDateRange[0]
            params.dateAfter = this.updatedDateRange[1]
        }

        if (this.typeFilterValues.length) {
            params.types = this.typeFilterValues;
        }

        if (this.saleTypeFilterValues.length) {
            params.saleTypes = this.saleTypeFilterValues;
        }

        if (this.saleStatusFilterValues.length) {
            params.saleStatuses = this.saleStatusFilterValues;
        }

        this.isTableLoading = true;

        this.httpGetSalesTaskList(params)
                .then((response) => {
                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalElements;
                    this.pagination = pagination;
                    this.table = response.data.content.map((i) => {
                        if (i.status === TaskStatus.INQUEUE) {
                            i.status = TaskStatus.CALCULATING
                            i.message = this.$t('reportsLog.taskStatuses.CALCULATING') as string
                        }
                        return i
                    });

                    if (this.table.length === 0 && this.activeTabKey === 'reportsLogTab') {
                        this.showInfo(this.$t('reportsLog.messages.infoNothingFound') as string);
                    }

                    callback(response.data.content);
                    clearTimeout(this.refreshTableTimeoutId);

                    this.refreshTableTimeoutId = setTimeout(() => {
                            this.fetchList(ctx, callback);
                    }, 20000);
                })
                .catch((e) => {
                    this.showError(this.$t('reportsLog.messages.errorLoadReports') as string);
                    callback([]);
                }).finally(() => {
                    this.isTableLoading = false;
                    this.isTableLoadingFirst = false;
                });

        if (this.usersFioList.length === 0) {
            this.httpGetUsersFio()
                    .then((response) => {
                        this.usersFioList = response.data.map((i) => {
                            return {value: i, label: i}
                        });
                        this.usersFioList.unshift({value: 'All', label: this.$t('shared.selectBox.all') as string});
                    })
                    .catch((e) => {
                        this.showError(this.$t('reportsLog.messages.errorLoadUsers') as string);
                    });
        }

        this.httpGetAllReportsIds(params)
                .then((response) => {
                    this.allReportsIds = response.data;
                })
                .catch((e) => {
                    this.showError(this.$t('reportsLog.messages.errorLoadReportNumbers') as string);
                });
    }

    selectOrClearAllReports(selected: boolean) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (selected) {
          this.isAllReportsSelected = true;
          this.selectedReportsArray = this.allReportsIds;
        } else {
          this.isAllReportsSelected = false;
          this.selectedReportsArray = [];
        }
      }, 100);
    }

    isSelectedTaskId(taskId: number) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        return index !== -1;
    }

    setSelectedTaskId(taskId: number, selected: boolean) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        if (selected) {
            if (index === -1) {
                this.selectedReportsArray.push(taskId);
            }
        } else {
            if (index !== -1) {
                this.selectedReportsArray.splice(index, 1);
            }
        }
    }

    moveFiltersToTableFilters(taskId: number) {
        this.showAction(
                this.$t('reportsLog.messages.confirmSetDefaultParamsSingle') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('shared.buttons.yes') as string,
                        onClick: () => {
                            const taskIds: number[] = []
                            taskIds.push(taskId)
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('reportsLog.messages.infoDefaultParamsSet') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('reportsLog.messages.errorSetFilterSingle', { id: taskId }) as string);
                                    });
                        },
                    }],
                });
    }

    moveFiltersToTableFiltersForCheckedReports(taskIds: number[]) {
        this.showAction(
                this.$t('reportsLog.messages.confirmSetDefaultParamsMultiple') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('shared.buttons.yes') as string,
                        onClick: () => {
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('reportsLog.messages.infoDefaultParamsSet') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('reportsLog.messages.errorSetFilterMultiple') as string);
                                    });
                        },
                    }],
                });
    }

    sendFileToFtpServer(taskId: number) {
        this.setButtonSectionLoaderState(taskId, true)
        this.httpSendReportToFtpServer([taskId])
                .then((response) => {
                    this.fetchList({
                        currentPage: this.pagination.current,
                        perPage: this.pagination.pageSize,
                    }, () => {});
                    const message = this.$t('reportsLog.messages.infoReportSentApproval') as string;
                    this.showInfo(message);
                })
                .catch((exception) => {
                    this.showError(this.$t('reportsLog.messages.errorSendApproval', { message: exception.response.data.message }) as string);
                })
            .finally(() => {
              this.setButtonSectionLoaderState(taskId, false)
            });
    }

    sendFileToFtpServerForCheckedReports(taskIds: number[]) {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.status !== TaskStatus.APPROVED && task.status !== TaskStatus.ONAPPROVAL
        });
        const filteredIds = filteredTable.map((task) => {
            return task.id
        });
        this.httpSendReportToFtpServer(filteredIds)
                .then((response) => {
                    const message = this.$t('reportsLog.messages.infoReportsSentApproval') as string;
                    this.showInfo(message);
                })
                .catch((exception) => {
                    this.showError(this.$t('reportsLog.messages.errorSendApprovalMultiple', { message: exception.response.data.message }) as string);
                });
    }

    canBeSendFileToFtpServerForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.status !== TaskStatus.APPROVED && task.status !== TaskStatus.ONAPPROVAL && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    canBeSaveForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    canBeMoveFiltersToTableFiltersForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.typeMachine !== TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS && task.typeMachine !== TaskType.SEARCH_KVI && task.typeMachine !== TaskType.PACKAGE_GENERAL
                    && task.typeMachine !== TaskType.PACKAGE_GENERAL_SCENARIO && task.typeMachine !== TaskType.PACKAGE_EVENTS_GENERAL && task.fileResult.length > 0 && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    clearFilters() {
        this.taskIdFilter = null;
        this.selectStatus = null;
        this.selectReportType = null;
        this.selectMarket = this.defaultFilterValue.value;
        this.selectGroup = this.defaultFilterValue.value;
        this.categoryOfProduct = this.defaultFilterValue.value;
        this.subCategoryOfProduct = [];
        this.typeFilterValues = [];
        this.saleTypeFilterValues = [];
        this.saleTypeFilterValues = [];
        this.saleStatusFilterValues = [];
        this.selectFormat = this.defaultFilterValue.value;
        this.selectRegion = [];
        this.selectCluster = this.defaultFilterValue.value;
        this.categoryOptions = [this.defaultFilterValue];
        this.subCategoryOptions = this.defaultMultipleValue;
        this.formatOptions = this.defaultMultipleValue;
        this.regionOptions = this.defaultMultipleValue;
        this.clusterOptions = this.defaultMultipleValue;
        this.selectUserFio = 'All';
        this.updatedDateRange = [];
        this.taskNoteFilter = null;

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})
    }

    handleFilter() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})
    }

  onFilterButtonClick() {
      this.handleFilter();
      this.selectOrClearAllReports(this.isAllReportsSelected);
  }

    resetByGroup() {
        this.resetData(TaskInfoFilterType.group)
    }

    resetByCategory() {
        this.resetData(TaskInfoFilterType.category)
    }

    resetByStoreFormat() {
        this.resetData(TaskInfoFilterType.format)
    }

    resetByStoreCluster() {
        this.resetData(TaskInfoFilterType.cluster)
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.subCategoryOfProduct)) {
            this.subCategoryOfProduct = list;
            this.resetBySubcategory();
        } else if (this.subCategoryOfProduct[0] === 0) {
            this.subCategoryOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.selectRegion)) {
            this.selectRegion = list;
            this.resetByStoreRegion();
        } else if (this.selectRegion[0] === 0) {
            this.selectRegion = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    showStopButton(task: TaskData): boolean {
        return task.typeMachine === TaskType.BRUT_FORCE && task.status === TaskStatus.CALCULATING
    }

    showGenerateReportButton(task: TaskData): boolean {
      const isTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      return !task.fileResult.length && isTaskReadyToBeGenerated && !task.needRecalculatePackageTask
    }

    showDownloadButton(task: TaskData): boolean {
      const restrictedStatuses = [
        TaskStatus.CALCULATING,
        TaskStatus.CALCULATING_COMPLETE,
        TaskStatus.WRITETOFILE
      ].map((v) => v.valueOf())

      return !!task.fileResult.length
          && !task.needRecalculatePackageTask
          && !(restrictedStatuses.includes(task.status))
    }

    showSetDefaultParamButton(task: TaskData): boolean {
      const restrictedTaskTypes = [
        TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS,
        TaskType.SEARCH_KVI,
        TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_SCENARIO,
        TaskType.PACKAGE_EVENTS_GENERAL,
      ]

      const isPackageTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      return !task.needRecalculatePackageTask
          && !restrictedTaskTypes.includes(task.typeMachine)
          && (task.fileResult.length > 0 || isPackageTaskReadyToBeGenerated)
    }

    showSaveFinalReportButton(task: TaskData): boolean {
        return task.status == TaskStatus.APPROVED && !!task.fileForRevaluationResult
    }

    showDownloadPriceButton(task: TaskData): boolean {
      const isPackageTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      const restrictedStatuses = [
        TaskStatus.CALCULATING,
        TaskStatus.CALCULATING_COMPLETE,
        TaskStatus.WRITETOFILE,
        TaskStatus.APPROVED,
        TaskStatus.ONAPPROVAL
      ].map((v) => v.valueOf())

      return taskTypesRequiresConfirmation.map((entry) => entry.value).includes(task.typeMachine)
          && (!task.needRecalculatePackageTask && !restrictedStatuses.includes(task.status))
          && (!!task.fileResult.length || isPackageTaskReadyToBeGenerated)
    }

    stopBrutForcing(taskId: number) {
        this.httpExecutor.executeHttp(this.httpStopBrutForce, taskId)
                .then((r) => {
                    if (!r.ignore) {
                        this.refreshTable();
                        const resp = r.response;
                        if (resp.status === 204) {
                            this.showInfo(this.$t('reportsLog.messages.infoParamSearchStopped') as string)
                        } else if (resp.status === 404) {
                            this.showInfo(this.$t('reportsLog.messages.infoParamSearchNotFound') as string)
                        } else {
                            this.showError(this.$t('reportsLog.messages.errorStopParamSearch') as string)
                        }
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('reportsLog.messages.errorStopParamSearch') as string)
                })
    }

    canBeShown(task: TaskData): boolean {
        const found = this.canBeShowTypes.findIndex((type) => task.typeMachine === type)
        if (found === -1) {
            return false;
        }

        return !task.needRecalculatePackageTask && (task.status === 'WriteToFileComplete' || task.status === 'OnApproval' || task.status === 'Rejected' || task.status === 'Approved');
    }

    handleTableRowClick(isExpanded: boolean, task: TaskData) {
        if (this.canBeShown(task)) {
            this.selectResult(isExpanded, task);
        }
    }

    selectResult(isExpanded: boolean, task: TaskData) {
        this.$router.push(`/sales/${task.id}`)
        let subCategories = ' - ';
        if (task.subcategories.length > 0) {
            subCategories = task.subcategories + ' / '
        }

        let formatName = ' - ';
        if (task.format !== '') {
            formatName = task.format + ' / '
        }

        let regionName = ' - ';
        if (task.region !== '') {
            regionName = task.region + ' / '
        }

        let clusterName = ' - ';
        if (task.cluster !== '') {
            clusterName = task.cluster + ' / '
        }
        const filters = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName
        this.taskToView = {
            id: task.id,
            status: task.status,
            type: task.typeMachine,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
            tradingId: task.tradingNetworks.id,
        };
        console.log(this.taskToView, "this.taskToView")

        // (this.$refs.resultViewTab as any).disabled = false;
        // (this.$refs.resultViewTab as any).activate();
        this.currentMainTab = "results"
    }

    selectPackageResult(task: ResultTableHeaders) {
        let subCategories = ' - ';
        if (task.subCategoryName !== '') {
            subCategories = task.subCategoryName + ' / '
        }

        let formatName = ' - ';
        if (task.formatName !== '') {
            formatName = task.formatName + ' / '
        }

        let regionName = ' - ';
        if (task.regionName !== '') {
            regionName = task.regionName + ' / '
        }

        let clusterName = ' - ';
        if (task.clusterName !== '') {
            clusterName = task.clusterName + ' / '
        }
        const filters = task.groupName + ' / ' + task.categoryName + ' / ' + subCategories + formatName + regionName + clusterName
        this.packageSubtask = {
            id: task.taskId,
            status: task.status,
            type: task.type,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
        };
        this.currentMainTab ="resultPackageViewTab"
        // (this.$refs.resultPackageViewTab as any).disabled = false;
        // (this.$refs.resultPackageViewTab as any).activate();
    }

    taskIdPrevent(e: any) {
        if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            return
        }
        if (!/^\d+$/.test(e.key)) {
            e.preventDefault();
        }
        this.refreshTable()
    }

    private refreshTable() {
        if (this.$route.params.hasOwnProperty('reportId')) {
            this.$router.push('/sales');
        }
        this.currentPage = 1;
        (this.$refs.tasksTable as any).refresh();
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        return {
            type: taskType,
            // tslint:disable-next-line: no-non-null-assertion
            tradingId: this.selectMarket!!,
            categories: LocalData.filterNumberArrays([this.categoryOfProduct], true),
            groups: LocalData.filterNumberArrays([this.selectGroup], true),
            subcategory: LocalData.filterNumberArrays(this.subCategoryOfProduct, true),
            segments: null,
            storeFormat: LocalData.filterNumberArrays([this.selectFormat], true),
            storeCluster: LocalData.filterNumberArrays([this.selectCluster], true),
            storeRegion: LocalData.filterNumberArrays(this.selectRegion, true),
            byReports: true,
        }
    }

    private resetBySubcategory() {
        this.resetData(TaskInfoFilterType.subcategory)
    }

    private resetByStoreRegion() {
        this.resetData(TaskInfoFilterType.region)
    }

    private resetData(type: TaskInfoFilterType | null = null) {
        switch (type) {
            case null:
                this.selectGroup = this.defaultFilterValue.value;
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.groupOptions = this.defaultMultipleValue;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                break;
            case TaskInfoFilterType.group:
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getCategoryInfo();
                this.getSubcategoryInfo();
                this.getStoreFormatsInfo();
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.category:
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getSubcategoryInfo();
                this.getStoreFormatsInfo();
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.subcategory:
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreFormatsInfo();
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.format:
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreRegionsInfo();
                this.getStoreClustersInfo();
                break;
            case TaskInfoFilterType.region:
                this.selectCluster = this.defaultFilterValue.value;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreClustersInfo();
                break;
        }
    }

    private getGroupInfo() {
        if (!this.selectMarket || this.selectMarket === -1) {
            return;
        }

        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    this.groupOptions = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.groupOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
                })
                .catch((e) => {
                })
    }

    private getCategoryInfo() {
        if (!this.selectMarket || this.selectMarket === -1) {
            return;
        }

        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    this.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.categoryOptions.unshift(this.defaultFilterValue);
                })
                .catch((e) => {
                })
    }

    private getSubcategoryInfo() {
        if (!this.selectMarket || this.selectMarket === -1) {
            return;
        }

        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    this.subCategoryOptions = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.subCategoryOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreFormatsInfo() {
        if (!this.selectMarket || this.selectMarket === -1) {
            return;
        }

        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    this.formatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.formatOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreRegionsInfo() {
        if (!this.selectMarket || this.selectMarket === -1) {
            return;
        }

        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    this.regionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.regionOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreClustersInfo() {
        if (!this.selectMarket || this.selectMarket === -1) {
            return;
        }

        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    this.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.clusterOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private viewReport(id: string) {
        const taskId = parseInt(id);
        if (taskId !== undefined) {
            this.httpLoadTaskById(taskId)
                    .then((resp) => {
                        if (resp.status === 200 && this.canBeShown(resp.data)) {
                            this.selectResult(false, resp.data)
                        } else {
                            this.showInfo(this.$t('resultView.messages.empty') as string);
                            this.$router.push('/sales');
                        }
                    })
                    .catch((ex) => {
                        this.showError(this.$t('resultView.messages.notFound') as string);
                        this.$router.push('/sales');
                    });
        }
    }

    private isFilterDisabled(): boolean {
      const market = this.selectMarket;
      return LocalData.zeroToNull(market) == null;
    }

    private toReportList() {
        this.$router.push('/sales');
        this.taskToView = null;
        this.currentMainTab = 'list';

        this.pagination = {
            current: 1,
            pageSize: 20,
        };

        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize
        }, () => {});
    }

    getSaleTypeLabel(typeValue: string | null = null) {
        if (!!typeValue) {
            const typeObj = this.saleTypeOptions.find(option => option.value === typeValue);

            return typeObj ? typeObj.label : this.$t('shared.messages.unknownType') as string;
        } else {
            return '';
        }
    }

    getSaleStatusLabel(typeValue: string | null = null) {
        if (!!typeValue) {
            const typeObj = this.saleStatusOptions.find(option => option.value === typeValue);

            return typeObj ? typeObj.label : this.$t('reportsLog.messages.unknownStatus') as string;
        } else {
            return '';
        }
    }

    get aggregatedReportStatusOptions(): Array<SelectBox<string>> {
        const defaultReportStatuses = ['Approved', 'PartiallyApproved'];
        const reportStatuses = [...new Set([
            ...defaultReportStatuses,
            ...this.table
                .map((item) => item.status)
                .filter((status): status is string => !!status)
        ])];

        return reportStatuses.map((status) => ({
            value: status,
            label: this.getTaskStatusLabel(status) || status,
        }));
    }

    createAggregatedReportBtnClick() {
        if (!this.isAllReportsSelected && !!this.selectedReportsArray.length) {
            Modal.confirm({
                title: this.$t('reportsLog.messages.confirmCreateCommonReportTitle') as string,
                content: this.$t('reportsLog.messages.confirmCreateCommonReportContent') as string,
                width: 600,
                centered: true,
                okText: this.$t('reportsLog.messages.okCreateCommonReport') as string,
                cancelText: this.$t('reportsLog.messages.cancelCreateCommonReport') as string,
                onOk: () => {
                    this.isCreateAggregatedReportBtnLoading = true;

                    this.httpSalesCreateAggregatedReport({
                        tradingId: this.$sales.selectMarket.id,
                        taskIds: this.selectedReportsArray,
                        groups: [],
                        categories: [],
                        subcategories: [],
                        storeFormats: [],
                        storeRegions: [],
                        storeClusters: [],
                        userIds: [],
                        startDate: '',
                        endDate: '',
                        saleTypes: [],
                        saleStatuses: [],
                        resultStatus: [],
                    }).then(() => {
                        this.showInfo(this.$t('reportsLog.messages.infoCommonReportStarted') as string, 5);
                    }).catch(() => {
                        this.showError(this.$t('reportsLog.messages.errorStartCommonReport') as string);
                    }).finally(() => {
                        this.isCreateAggregatedReportBtnLoading = false;
                    });
                },
                onCancel: () => {
                    this.isRenderAggregatedReportCreationModal = true;
                    this.isAggregatedReportCreationModalVisible = true;
                },
            });
        } else {
            this.isRenderAggregatedReportCreationModal = true;
            this.isAggregatedReportCreationModalVisible = true;
        }
    }
}
